<template>
  <div>
    <v-chart v-if="embed" :option="options" :init-options="{renderer: 'svg'}" autoresize style="width: 100%; height: 300px;"/>
    <text-box v-else :label="$t('components.MicroaudienceCompositionGraph.title')" icon="chart-bar">
      <template v-slot:info v-if="precision">
        <percent-chip :value="precision" :best="100" icon="mdi-bullseye-arrow"/>
      </template>
      <template v-slot:info-dialog>
        {{ $t('components.MicroaudienceCompositionGraph.infoDialog') }}
      </template>
      <v-chart :option="options" :init-options="{renderer: 'svg'}" autoresize style="width: 100%; height: 300%;"/>
    </text-box>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import { graphic } from 'echarts/core'
import 'zrender/lib/svg/svg'
import numbro from 'numbro'

import TextBox from '@/components/TextBox.vue'
import PercentChip from '@/components/PercentChip.vue'

export default {
  data () {
    return {}
  },
  computed: {
    options () {
      return {
        textStyle: {
          fontFamily: '"Roboto","Helvetica",sans-serif',
          lineHeight: 1.2381,
          fontWeight: 400
        },
        grid: {
          top: '2%',
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        tooltip: {
          show: true,
          formatter: this.formatEchartsValue
        },
        xAxis: {
          type: 'category',
          splitLine: {
            show: false
          },
          axisLabel: {
            rotate: 75
          },
          data: this.slice ? this.data.names.slice(0, this.slice) : this.data.names
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: false
          },
          axisLabel: {
            formatter: this.formatValue
          },
          max: this.yAxisMax ? this.yAxisMax : null
        },
        series: {
          name: this.$t('components.MicroaudienceCompositionGraph.kpi'),
          type: 'bar',
          label: {
            show: false,
            position: 'top',
            formatter: this.formatEchartsValue
          },
          itemStyle: {
            color: new graphic.LinearGradient(0, 2, 0, 0, [
              { offset: 0, color: 'white' },
              { offset: 1, color: '#6950a1' }
            ]),
            borderRadius: [2, 2, 0, 0]
          },
          data: this.slice ? this.data.values.slice(0, this.slice) : this.data.values
        }
      }
    },
    total: function () {
      return this.data.values.reduce((a, b) => a + b)
    }
  },
  methods: {
    formatValue: function (value) {
      return numbro(value).format({
        average: true,
        lowPrecision: false,
        mantissa: 1,
        optionalMantissa: true
      })
    },
    formatEchartsValue: function (obj) {
      return `${this.formatValue(obj.value)}%`
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    precision: {
      type: Number,
      required: false
    },
    embed: {
      type: Boolean,
      required: false
    },
    slice: {
      type: Number,
      required: false
    },
    yAxisMax: {
      type: Number,
      required: false
    }
  },
  components: {
    'v-chart': ECharts,
    TextBox,
    PercentChip
  }
}
</script>
